import { Flex, Select } from "antd"
import { useFetchProducts } from "../../products/hooks/useFetchProducts";
import type { ProductData } from "../../products/types";
import type { QuoteProduct } from "../types";
import openNotification from "../../../utils/openNotification";
import SkeletonNode from "../../shared/components/SkeletonNode";
import { Text } from "@react-pdf/renderer";
import EmptyData from "../../shared/components/EmptyData";

interface PropsFormProduct {
    handleChangeProduct: (value: ProductData | undefined) => void
    selectedProducts: QuoteProduct[]
}

const FormNewProduct = ({ handleChangeProduct, selectedProducts }: PropsFormProduct) => {
    const { data: products, isLoading: isLoadingProdducts } = useFetchProducts();

    if (isLoadingProdducts) return <section style={{ width: "100%" }}><SkeletonNode rows={1} /></section>
    if (products && (products.length === 0 || products.length === selectedProducts.length)) return <EmptyData description="No hay productos disponibles" />

    return <Flex vertical gap={6}>
        <Text>
            Seleciona un producto
        </Text>
        <Select
            showSearch={{
                filterOption: (input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
            }}
            style={{ width: '100%', marginBottom: 10 }}
            placeholder="Seleciona un producto"
            loading={isLoadingProdducts}
            // Se deja vacío tras agregar para que se note que se puede seguir
            // seleccionando más productos.
            value={null}
            onChange={(value) => {
                const product = products?.find((item) => item.id_product === value);
                if (selectedProducts.find((item) => item.id_product === product?.id_product)) {
                    openNotification('error', 'Error', 'El producto ya ha sido agregado');
                    return;
                }
                handleChangeProduct(product);
            }}
            options={products ? products.filter((item) => {
                return !selectedProducts.find((selectedProduct) => selectedProduct.id_product === item.id_product);
            }).map((item) => {
                return {
                    label: `${item.product_type}: ${item.product_name}`,
                    value: item.id_product
                }
            }) : []} />
    </Flex>
}

export default FormNewProduct